import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PointStoreNavigationBarService {

  data: any = {
    selectedNavBarSection: 0,
  }

  wizardFormData: any = {
    index: 0,
  }

  constructor() { }

  setSelectedFrame(index) {
    this.data.selectedNavBarSection = index;
  };

  getSelectedFrame() {
    return this.data.selectedNavBarSection;
  };

  setWizardIndex(index: number): void {
    this.wizardFormData.index = index;
  }

  getWizardIndex(): number {
    return this.wizardFormData.index;
  }

}
